import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Event sent when board templates are generated',
  name: 'board_templates_generated',
  params: [
    {
      description: 'The generation prompt used to create the templates',
      name: 'prompt',
      required: true,
      type: 'string',
    },
    {
      description: 'The number of board templates generated',
      name: 'number_of_boards',
      required: true,
      type: 'number',
    },
  ],
};

export default META;
